(function () {
    'use strict';

    angular
        .module('franchiser.services')
        .service('BankAccountService', BankAccountService)

    /** @ngInject */
    function BankAccountService(HttpService) {
        const BankAccountService = {
            getByUnitId: getByUnitId,
            getByUnitEconomicGroup: getByUnitEconomicGroup,
            postBankAccount: postBankAccount,
            putBankAccount: putBankAccount
        }

        return BankAccountService;

        function getByUnitId(unitId) {
            return HttpService.get(`/banks/accounts/by-unit/${unitId}`);
        }

        function getByUnitEconomicGroup(economicGroupId) {
            return HttpService.get(`/banks/accounts/by-economic-group/${economicGroupId}`);
        }

        function postBankAccount(bankAccount) {
            return HttpService.post('/banks/accounts', bankAccount);
        }

        function putBankAccount(bankAccount, disableAccount) {
            return HttpService.put(`/banks/accounts/${disableAccount}`, bankAccount);
        }
    }
}());